import React, { useState, useEffect, useRef } from 'react';

function IntroductionContainer() {

    return(
        <article className="layout-contents-container page-introduction">

            <div className="about-container">
                <aside className="about-companies">
                    <h2 className="company">ONE O ONE architects</h2>
                    <p>
                        4F 115-9 daesin-dong,<br/>
                        seodaemun-gu, seoul, korea<br/>
                        (postal code 03721)<br/>
                        T. +82 2 739 6363<br/>
                        F. +82 2 739 6362 <br/>
                        recruit@101-architects.com<br/>
                        www.101-architects.com<br/>
                    </p>

                    <h2 className="company">ONE O ONE factory</h2>
                    <p>
                        3F 115-9 daesin-dong,<br/>
                        seodaemun-gu, seoul, korea<br/>
                        (postal code 03721)<br/>
                        T. +82 2 739 6363<br/>
                        F. +82 2 739 6362<br/>
                        www.101-factory.com<br/>
                    </p>


                    <h2 className="company">ONE O ONE plus</h2>
                    <p>
                        1F 126-2 Susong-dong, Jongno-gu,<br/>
                        seoul, korea (postal code 03152)<br/>
                        T. +82 2 722 6700<br/>
                        www.101-plus.com<br/>
                    </p>
                </aside>

                <section className="introduction">
                    <h1 className="hidden">introduction</h1>

                    <div className="media"></div>

                    <p className="description">
                        Architecture is the image of life fabricated with sensitivity. It is the landscape not by one's eyes but by one's heart. Space is not merely a matter of form but the abstraction of human life and collective memories of events and experiences. As Mishia Yokio, who was interested in the edges of human body once said- ‘sprit can't expand its existence outside of human skin even 1mm'-body is the evidence of the human existence. Landscape and objects are not objects but the individual results of the expanded human contemplation and self-multiplication.<br/>
                        <br/>
                        Since the establishment of global capitalism in early 80's, Italian architectural theorist Manfredo Tafuri started to concentrate on studying Renaissance Architecture, proclaiming that human life and culture were not directed by architecture itself. Still, he argues that given the situation that discussions over modernism thrived through architectural magazines and architects' arguments, it is necessary to question over modern architecture reinterpreting the reality of the history by reviewing past architecture and its architects.<br/>
                        <br/>
                        After Hegel's ‘zeitgeist', criticism-oriented western history writing has begun, which neglected local cultural differences. Heidegger on the contrary, though he directly didn't mention architectural aesthetics, opened the opportunity to integrate architecture with vivid landscape and locality by mentioning the subject of architecture and human life. Being interested in human culture, ONE O ONE architects' main priority is to capture the value of locality and cultural landscape and human studies rather than to represent an abstract concept by periodic classifications of architecture.<br/>
                        <br/>
                        Innami, one of partners in ONE O ONE is interested in environmental design through preservation of local cultural heritages, cultural policies for artists and craftsmen and development of new aesthetics according to the possible changes under the previous two conditions. ONE O ONE's design vision and future directions are heavily rely on his human studies. Our design fields covers vast areas from urban cultural planning to craft goods design.<br/>
                        <br/>
                        Our work culture is mainly based on collaboration from various backgrounds and character being focused on tangible human experience rather than formal and conceptual design practice.<br/>
                        <br/>
                        Design is, for us, conversation with the sight we encountered and perspectives drawn from the exchanges of aesthetic view.<br/>
                        <br/>

                        <span className="choi-wook">
                            <strong>Choi Wook</strong><br/>
                            <br/>
                            Architect<br/>
                            Domus Korea - Editor & Publisher
                        </span>
                    </p>
                </section>
            </div>

            <ol className="list-intro">
                <li>
                    <div className="intro-item">
                        <div className="info">
                            <time dateTime="" className="date">2020.01.25</time>
                            <strong className="title">ONE O ONE Office</strong>
                            <p className="description">
                                3rd floor entrance with warm light<br />
                                <br />
                                Photo. Jang Mi<br />
                            </p>
                        </div>
                        <div className="media">
                            <div className="inner">
                                <a href="#" className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></a>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="intro-item">
                        <div className="info">
                            <time dateTime="" className="date">2020.01.25</time>
                            <strong className="title">ONE O ONE Office</strong>
                            <p className="description">
                                3rd floor entrance with warm light<br />
                                <br />
                                Photo. Jang Mi<br />
                            </p>
                        </div>
                        <div className="media">
                            <div className="inner">
                                <a href="#" className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></a>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="intro-item">
                        <div className="info">
                            <time dateTime="" className="date">2020.01.25</time>
                            <strong className="title">ONE O ONE Office</strong>
                            <p className="description">
                                3rd floor entrance with warm light<br />
                                <br />
                                Photo. Jang Mi<br />
                            </p>
                        </div>
                        <div className="media">
                            <div className="inner">
                                <a href="#" className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></a>
                            </div>
                        </div>
                    </div>
                </li>
            </ol>

            <div className="list-actions">
                <button type="button" className="button-read-more">Read More</button>
            </div>

        </article>
    );
}

export default IntroductionContainer;
